export default "__VITE_ASSET__DTTAJCGL__"